<template>
  <div class="nav-f">
    <div class="nav">
      <div class="container">
        <div class="nav-left">
          <img class="logo" src="./img/logo.png" alt="" />
          <div class="site-title">
            <div>欢迎来到</div>
            <h2>{{ orgInfo.orgName }}</h2>
          </div>
        </div>
        <div class="nav-list" v-if="headerMenu">
          <a
            v-for="item in nav"
            :key="item.name"
            :href="'./' + item.name + '.html'"
            :class="{ active: active === item.name }"
            >{{ item.title }}</a
          >
        </div>
        <div class="nav-right" v-if="headerMenu">
          <Dropdown v-if="isLogin">
            <div class="phone">
              <div class="phone">{{ phone }}</div>
              <i class="el-icon-caret-bottom"></i>
            </div>
            <DropdownMenu slot="dropdown">
              <DropdownItem @click.native="minePage">个人资料</DropdownItem>
              <DropdownItem @click.native="forgetPassword"
                >修改密码</DropdownItem
              >
              <DropdownItem
                v-if="studyInfo.certificateOpenFlag"
                @click.native="certificate"
                >我的证书
              </DropdownItem>
              <DropdownItem @click.native="loginOut">退出帐号</DropdownItem>
            </DropdownMenu>
          </Dropdown>
          <ElButton v-else size="medium" @click.native="goLogin" type="primary"
            >尚未登录</ElButton
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Button as ElButton
} from "element-ui";
import { setOrgInfo } from "@/utils/org.js";
import {
  removeToken,
  getToken,
  getUserInfo,
  encryptPhone
} from "@/utils/common.js";
import { getUserStudyInfo } from "@/api/mine";
export default {
  name: "NavBar",
  props: {
    active: {
      type: String,
      default: ""
    },
    headerMenu: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      nav: [
        {
          title: "首页",
          name: "index"
        },
        {
          title: "学习",
          name: "studyIndex"
        },
        {
          title: "考试",
          name: "examIndex"
        },
        {
          title: "错题本",
          name: "topicWrong"
        },
        {
          title: "开通课程",
          name: "bindCourseCard"
        }
      ],
      phone: getUserInfo("phone") ? encryptPhone(getUserInfo("phone")) : "",
      orgInfo: {},
      isLogin: getToken() || "",
      studyInfo: {}
    };
  },
  created() {
    setOrgInfo(r => {
      this.orgInfo = r;
      if (this.isLogin) {
        getUserStudyInfo().then(res => {
          this.studyInfo = res;
        });
      }
    });
  },
  methods: {
    goLogin() {
      window.location.href = "./loginIndex.html";
    },
    loginOut() {
      removeToken();
      window.location.href = "./loginIndex.html";
    },
    minePage() {
      window.location.href = "./mineIndex.html";
    },
    forgetPassword() {
      window.location.href = "./forgetPassword.html";
    },
    certificate() {
      window.location.href = "./certificate.html";
    }
  },
  components: { Dropdown, DropdownItem, DropdownMenu, ElButton }
};
</script>

<style scoped lang="scss">
@import "../../assets/style/var.scss";
.nav-f {
  height: $--nav-bar-height;
  width: 100%;
  .nav {
    position: fixed;
    top: 0;
    left: 0;
    height: $--nav-bar-height;
    width: 100%;
    background-color: #fff;
    z-index: 10;
    box-shadow: 0 0 6px 0 rgba(236, 236, 241, 1);
    .container {
      width: $--container-width;
      margin: 0 auto;
      display: flex;
      align-items: center;
      height: 100%;
      .nav-left {
        display: flex;
        .logo {
          width: 40px;
          height: 40px;
        }
        .site-title {
          margin-left: 10px;
          .tip {
            font-size: 16px;
            color: #999;
          }
          h2 {
            margin: 0;
            color: #333;
            font-size: 20px;
          }
        }
      }
      .nav-list {
        margin: 0 66px;
        flex: 1;
        justify-content: space-around;
        display: flex;
        list-style-type: none;
        a {
          color: #333;
          text-decoration: none;
          font-size: 18px;
          &:hover,
          &.active {
            color: $--color-primary;
          }
        }
      }
      .nav-right {
        cursor: pointer;
        .phone {
          display: flex;
          color: #000;
          font-size: 18px;
        }
      }
    }
  }
}
</style>
